import * as Blockly from 'blockly/core'

const SOUND_OPTIONS = [
  ['ting', 'ting'],
  ['boink', 'boink'],
  ['applause', 'applause'],
]

const AUDIO_OPTIONS = [
  ['happy', 'happy'],
  ['calm', 'calm'],
]

export function registerSoundBlocks() {
  Blockly.common.defineBlocksWithJsonArray([
    {
      type: 'sound_play',
      message0: '🔊 bunyi %1',
      args0: [{ type: 'field_dropdown', name: 'SOUND', options: SOUND_OPTIONS }],
      previousStatement: null,
      nextStatement: null,
      colour: 120,
      tooltip: 'Mainkan efek suara',
    },
    {
      type: 'sound_loop',
      message0: '🎵 audio loop %1',
      args0: [{ type: 'field_dropdown', name: 'AUDIO', options: AUDIO_OPTIONS }],
      previousStatement: null,
      nextStatement: null,
      colour: 120,
      tooltip: 'Mainkan musik latar berulang',
    },
    {
      type: 'sound_stop',
      message0: '🔇 stop bunyi',
      previousStatement: null,
      nextStatement: null,
      colour: 120,
      tooltip: 'Hentikan semua suara',
    },
  ])
}
